import React from 'react';
import MetricInfoIcon from '../../../components/MetricInfoIcon';
import { getPromptPulseMetricDefinition } from '../utils/promptPulseMetricDefinitions';

export default function GeoMetricInfoIcon({
  metricKey,
  text,
  title,
  ariaLabel,
  className = 'geo-metric-info',
  iconSize = 14,
}) {
  const body = text || getPromptPulseMetricDefinition(metricKey);
  if (!body) return null;

  return (
    <MetricInfoIcon
      text={body}
      title={title}
      ariaLabel={ariaLabel}
      className={className}
      iconSize={iconSize}
    />
  );
}
